module.exports = __webpack_public_path__ + "static/media/vf_wdress_core.bf4a6e55.svg";